'use client'

import { useEffect } from 'react'
export function HyperDXBrowserInit() {
  useEffect(() => {
    const apiKey = process.env.NEXT_PUBLIC_HYPERDX_API_KEY!
    if (!apiKey) return
    import('@hyperdx/browser').then(({ default: HyperDX }) => {
      HyperDX.init({
        apiKey,
        service: 'algoacademy-browser',
        url: process.env.NEXT_PUBLIC_HYPERDX_OTLP_ENDPOINT,
        maskAllInputs: true,
        maskAllText: false
      })
    })
  }, [])

  return null
}
